<template>
  <q-dialog :visible="isVisible" :title="title" width="830px" :innerScroll="false" :showFooter="false" @close="onCancel" v-esc-close>
    <div class="content" v-loading="loading">
      <div v-if="rowData.imgType == 1">
        <div class="label-name">视觉拍摄原图：</div>
        <div class="img-box">
          <div v-for="(item, index) in visionImgList" :key="index" @click="visionIndex = index">
            <el-image :src="item" alt="" :preview-src-list="visionImgList" :initial-index="visionIndex"></el-image>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="label-name">正面图片：</div>
        <div class="img-box">
          <div v-for="(item, index) in positiveImgList" :key="index" @click="positiveIndex = index">
            <el-image :src="item" alt="" :preview-src-list="positiveImgList" :initial-index="positiveIndex"></el-image>
          </div>
        </div>
        <div class="label-name">背面图片：</div>
        <div class="img-box">
          <div v-for="(item, index) in backImgList" :key="index" @click="backIndex = index">
            <el-image :src="item" alt="" :preview-src-list="backImgList" :initial-index="backIndex"></el-image>
          </div>
        </div>
        <div class="label-name">其他补充图片：</div>
        <div class="img-box">
          <div v-for="(item, index) in otherImgList" :key="index" @click="otherIndex = index">
            <el-image :src="item" alt="" :preview-src-list="otherImgList" :initial-index="otherIndex"></el-image>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <el-button @click="onCancel">关闭</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'CRUDEdit',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return this.isVision ? '视觉拍样图' : '首套试制图';
    },
    name() {
      return this.$store.state.user.name;
    },
    isVision() {
      return this.rowData.imgType == 1;
    },
  },
  data() {
    return {
      loading: false,
      visionIndex: 0,
      positiveIndex: 0,
      backIndex: 0,
      otherIndex: 0,
      visionImgList: [
        // 'https://ecocs.quanyou.com.cn/goods-new-stg/%E6%96%B0%E5%93%81%E4%B8%8A%E6%9E%B6/%E4%BF%AE%E7%89%87/%E6%96%B0/600620%E6%A8%A1%E5%9D%97%E4%B9%A6%E6%9F%9CB5136N%23/%E6%9C%80%E6%96%B0/%E5%A4%A7%E7%89%87/%E5%A4%A7%E7%89%871.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12566.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12572.jpg',
        // 'https://eco.quanyou.com.cn/dsglfiles/新品上架/修片/旧/修片/2023年/12月/102582AⅠ皮乳胶沙发 102582A-1皮沙发 DW1116矮圆茶几A+高边几组合 DW1160岛台+餐桌+DW1155餐椅  修片+李阳+璟禾映画 2023.12.19/大片/RAW12671.jpg',
      ],
      positiveImgList: [],
      backImgList: [],
      otherImgList: [],
    };
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    async init() {
      this.loading = true;
      this.$q.newProduct
        .productCheckImgViewUploadImg({ fragment: [this.rowData.id] })
        .then((res) => {
          this.visionImgList = this.getImg(res.data, 1);
          this.positiveImgList = this.getImg(res.data, 2);
          this.backImgList = this.getImg(res.data, 3);
          this.otherImgList = this.getImg(res.data, 4);
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    getImg(list, type) {
      const imgList = list.find((v) => v.dataType == type);
      return imgList ? imgList.imgUrls : [];
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>

.content {
  box-sizing: border-box;
  max-height: 70vh;
  overflow-y: auto
  padding: 15px
}

.label-name {
  font-size: 14px
  margin: 15px 0
}

.img-box {
  display: flex
  min-height: 120px

    div {
      cursor: pointer
      width: 120px
      height: 120px
      margin-right: 10px
    }
}

.footer {
  text-align: center
  margin-top: 30px
}

>>> .el-dialog {
  margin-top: 50px !important
}
</style>
